<div class="sigpad">
  <div class="sigpad-tabs">
    <button
      type="button"
      class="sigpad-tab"
      [class.active]="mode === 'draw'"
      (click)="setMode('draw')"
    >
      <app-icon name="edit" [size]="15" /> {{ 'signature_pad.draw_tab' | translate }}
    </button>
    <button
      type="button"
      class="sigpad-tab"
      [class.active]="mode === 'upload'"
      (click)="setMode('upload')"
    >
      <app-icon name="upload" [size]="15" /> {{ 'signature_pad.upload_tab' | translate }}
    </button>
  </div>

  <div class="sigpad-canvas-wrap" *ngIf="mode === 'draw'">
    <canvas #canvas class="sigpad-canvas"></canvas>
  </div>

  <div class="sigpad-upload" *ngIf="mode === 'upload'">
    <div class="sigpad-upload-preview" *ngIf="uploadedPreviewUrl">
      <img [src]="uploadedPreviewUrl" alt="Firma caricata" />
      <button type="button" class="sigpad-upload-remove" (click)="clearUpload()">
        {{ 'signature_pad.upload_remove' | translate }}
      </button>
    </div>
    <label class="sigpad-upload-dropzone" *ngIf="!uploadedPreviewUrl">
      <input type="file" accept="image/png" (change)="onFileSelected($event)" hidden />
      <span><app-icon name="upload" [size]="16" /> {{ 'signature_pad.upload_cta' | translate }}</span>
    </label>
    <p class="sigpad-upload-error" *ngIf="uploadError">{{ uploadError | translate }}</p>
  </div>
</div>
